import React from 'react';

import MovedPage from './components/MovedPage';
import { localeFromSearch } from './content';

function App() {
  return <MovedPage locale={localeFromSearch(window.location.search)} />;
}

export default App;
